export default __webpack_public_path__ + "f0b04661dcb4329782ce7c5cacf4b1bd.png";